function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M255.66,112c-77.94,0-157.89,45.11-220.83,135.33a16,16,0,0,0-.27,17.77C82.92,340.8,161.8,400,255.66,400,348.5,400,429,340.62,477.45,264.75a16.14,16.14,0,0,0,0-17.47C428.89,172.28,347.8,112,255.66,112Z",
    style: {
      fill: "none",
      stroke: "#A4A4A4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 52
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 80,
    style: {
      fill: "none",
      stroke: "#A4A4A4",
      strokeMiterlimit: 10,
      strokeWidth: 52
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowEye);
export default __webpack_public_path__ + "static/media/show-eye.09d8d42652882959e75e6cdaafa7fc44.svg";
export { ForwardRef as ReactComponent };